<template>
  <div class="usersSetting">
    <router-view :route-loading="loading"></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'UsersSetting',
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions('settings', ['fetchUserAvatarList', 'setNewUserCamList']),
    async init() {
      try {
        this.loading = true;
        await this.fetchUserAvatarList();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.usersSetting {
  height: 100%;
}
</style>
